module.exports = __webpack_public_path__ + "img/zi.748c4a7d.png";